/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Compare_Platforms_GcInputs */

const en_gc_resources_compare_platforms_gc = /** @type {(inputs: Gc_Resources_Compare_Platforms_GcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows, macOS, Linux and web`)
};

const zh_gc_resources_compare_platforms_gc = /** @type {(inputs: Gc_Resources_Compare_Platforms_GcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows、macOS、Linux 和网页`)
};

/**
* | output |
* | --- |
* | "Windows, macOS, Linux and web" |
*
* @param {Gc_Resources_Compare_Platforms_GcInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_compare_platforms_gc = /** @type {((inputs?: Gc_Resources_Compare_Platforms_GcInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Compare_Platforms_GcInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_compare_platforms_gc(inputs)
	return zh_gc_resources_compare_platforms_gc(inputs)
});
export { gc_resources_compare_platforms_gc as "gc.resources.compare.platforms.gc" }